import { bus } from '@/utils/bus'
import { envTypeData } from '@/utils/public'
import BindEnv from '@/components/bind-env/bind-env'
import { generateQrcode } from "@/api/admin";

import Vue from 'vue';
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

export default {
  name: 'layout-sidebar',
  components: {
    // Company,
    BindEnv,
  },
  data() {
    return {
      envTypeData,
      nickname: this.$store.getters.username,
      collapsed: false,
      currentEnv: '集成环境',
      envItemName: '正式环境',
      // clientId: this.$store.getters.currentClientId,
      // environment: this.$store.getters.envType,
      // defaultEnvOfTwo: this.$store.getters.defaultEnvOfTwo,
      userLoginInfo: this.$store.getters.userLoginInfo,
      envAccount_dv: false,
      isMasterBind: !!this.$store.getters.userLoginInfo.clientId, // 正式环境是否绑定
      isTestBind: !!this.$store.getters.userLoginInfo.testClientId, // 集成环境是否绑定
      QRcodeDialogVisible:false,
      loading:false,
      qrCode:'',
      justSZRZ: false
    }
  },
  computed: {
    defaultActiveIndex() {
      return this.$store.getters.defaultActiveIndex
    },
    clientId() {
      // 这里做一下转换是因为client被改变之后,如果引用的是同一个指针,会监听不到变化
      return JSON.parse(JSON.stringify(this.$store.getters.currentClientId))
    },
    environment() {
      return this.$store.getters.envType
    },
    defaultEnvOfTwo() {
      return this.$store.getters.defaultEnvOfTwo
    },
    username() {
      return this.$store.getters.username
    },
    isGoHomeBtn() {
      return this.$store.getters.isGoHomeBtn;
    },
    currentAppShow() {
      return this.$store.getters.currentAppShow;
    }
  },
  watch: {
    clientId(newName, oldName) {
      console.log('监听切换的currentClientId', newName)
      // 判断浏览器类别
      // const { userAgent } = navigator; // 取得浏览器的userAgent字符串
      // console.log('userAgent',userAgent)
      // console.log('window.location',window.location)
      // if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
      //   window.location.reload(true);
      // } else {
      //   this.$router.go(0);
      // }
      // window.location.reload(true);
    },
    defaultActiveIndex() {
      // console.log(newIndex, oldIndex)
    },
    username(newVal) {
      this.nickname = newVal
    },
  },
  created() {
    this.$store.commit('loginStore/SET_ActiveIndex', this.$route.path)
    // this.defaultActiveIndex = this.$route.path
    bus.$on('setNickName', (text) => {
      this.nickname = text
    })
    // 未登录的判断
    bus.$on('goto', (url) => {
      if (url === '/login') {
        // localStorage.removeItem('access-user')
        // localStorage.removeItem('access-authType')
      }
      this.$router.push(url)
    })
  },
  mounted() {
    if(VueCookies.get('justSZRZ')==='true') {
      this.justSZRZ = 'true'
    }
    
  },
  methods: {
    backHome() {
      window.location.href = "../page/index.html";
      // window.location.href = "http://127.0.0.1:8080/#/procedurelist/statistics";
    },
    handleSelect(index) {
      this.$store.commit('loginStore/SET_ActiveIndex', index)
      // this.defaultActiveIndex = index
    },
    // 折叠导航栏
    collapse() {
      this.collapsed = !this.collapsed
    },
    jumpTo(url) {
      this.$store.commit('loginStore/SET_ActiveIndex', url)
      // this.defaultActiveIndex = url
      this.$router.push(url) // 用go刷新
    },
    logout() {
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonClass: 'el-button--warning',
      })
        .then(() => {
          // 确认
          this.$cookies.remove('userLoginInfo')
          this.$cookies.remove('envType')
          this.$cookies.remove('currentClientId')
          this.$cookies.remove('username')
          this.$cookies.remove('defaultEnvOfTwo')
          // window.location.href = 'http://127.0.0.1:8080/ywx-open/html/homeList/productInfo.html##';
          window.location.href = '../homeList/homePage.html'
        })
        .catch(() => {})
    },

    // 调用集成环境绑定窗口
    tobindTestEnv() {
      this.envAccount_dv = true
      // this.isMasterBind = true
      // this.isTestBind = false
    },
    // 关闭环境绑定窗口
    cancelTestEnvDialog(dialogVal) {
      this.envAccount_dv = dialogVal
      // this.isTestBind = isTestBindVal
    },
    // 调用正式环境绑定窗口
    tobindMasterEnv() {
      this.envAccount_dv = true
      // this.isMasterBind = false
      // this.isTestBind = true
    },
    // 正式环境切换为集成环境
    async changeToTest() {
      console.log('正式切集成', this.clientId)
      if (
        this.environment === envTypeData.test ||
        (this.environment === envTypeData.allEnv &&
          this.defaultEnvOfTwo === envTypeData.test)
      ) {
        return
      }
      // 登录集成环境会话
      const successCode = await this.$store.dispatch('loginStore/synLogin')
      console.log('successCode', successCode)
      if (successCode === '100') {
        this.$store.dispatch('loginStore/defaultEnv', 'test')
        window.location.reload(true)
      }
    },
    // 集成环境切换正式环境  这里不需要请求接口
    changeToMaster() {
      if (
        this.environment === envTypeData.master ||
        (this.environment === envTypeData.allEnv &&
          this.defaultEnvOfTwo === envTypeData.master)
      ) {
        return
      }
      this.$store.dispatch('loginStore/defaultEnv', 'master')
      window.location.reload(true)
    },
    // 查看医院二维码
    checkQrCodeImg() {
      this.QRcodeDialogVisible=true
      this.loading = true;
      generateQrcode()
        .then((res) => {
          this.qrCode = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 下载图片
    async downloadPng() {
      const aEl = document.createElement("a");
      //设置href指向
      aEl.href = this.qrCode;
      //设置图片下载名字
      aEl.download = "二维码";
      aEl.click();
    },
  },
}
